module.exports = __webpack_public_path__ + "static/media/twitter.ba7771e0.svg";